<template>
  <div>
    <v-btn @click="showModal()" :round="round" small ref="test">options</v-btn>

    <v-dialog v-model="enabled" @keydown.esc.prevent="closeOptionsModal()" :fullscreen="$vuetify.breakpoint.xsOnly" @input="v => v || closeOptionsModal()">
      <v-card>
        <v-container fluid pa-0 ma-0 fill-height>
          <v-layout row>
            <v-flex xs4 max-width="200px" style="display:flex; flex-direction:column; justify-content:space-between;">
              <v-list pa-0 ma-0 >
                <v-list-tile
                  @click="panel = 'details'"
                  :color="panel === 'details' ? 'primary' : ''"
                >
                  <v-list-tile-action style="min-width:36px">
                    <v-icon>fa-info-circle</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Details</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile
                  @click="panel = 'associated'"
                  :color="panel === 'associated' ? 'primary' : ''"
                  v-if="transactionDetails.associatedTransactions && transactionDetails.associatedTransactions.length && transactionDetails.associatedTransactions.reduce((a, c) => c.request_type !== 'modify' ? ++a : a, 0)"
                >
                  <v-list-tile-action style="min-width:36px">
                    <v-icon>fa-sitemap</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Associated</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile
                  @click="panel = 'refund'"
                  :color="panel === 'refund' ? 'primary' : ''"
                  v-if="(hasPermission('can_manage_transactions') || hasPermission('can_manage_account_transactions')) && ( transactionDetails.request_type === 'sale' || ( transactionDetails.request_type === 'ach' && transactionDetails.ach_status_id > 2 ) ) && transactionDetails.response_code==='000' && transactionDetails.settled && !transactionDetails.voided && credited < transactionDetails.total_amount"
                >
                  <v-list-tile-action style="min-width:36px">
                    <v-icon>fa-times-circle-o</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      Refund
                      <Lightbulb>
                        <template v-slot:message>
                          <span>Allows you to refund a customer's payment or give a partial refund.</span>
                        </template>
                      </Lightbulb>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile
                  @click="panel = 'void'"
                  :color="panel === 'void' ? 'primary' : ''"
                  v-if="(hasPermission('can_manage_transactions') || hasPermission('can_manage_account_transactions')) && ( transactionDetails.request_type === 'sale' || transactionDetails.request_type === 'credit' || transactionDetails.request_type === 'ach' || transactionDetails.request_type === 'achcredit') && transactionDetails.response_code === '000' && !transactionDetails.settled && !transactionDetails.voided && !transactionDetails.refunded"
                  >
                  <v-list-tile-action style="min-width:36px">
                    <v-icon>fa-times-circle-o</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      Void
                      <Lightbulb>
                        <template v-slot:message>
                          <span>Allows you to cancel same day transactions.</span>
                        </template>
                      </Lightbulb>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <!--
                <v-list-tile
                  @click="panel = 'waive'"
                  :color="panel === 'waive' ? 'primary' : ''"
                  v-if="(hasPermission('can_manage_transactions') || hasPermission('can_manage_account_transactions')) && transactionDetails.request_type === 'sale' && transactionDetails.response_code === '000' && !transactionDetails.settled && !transactionDetails.voided && !transactionDetails.refunded && !transactionDetails.is_fee_waived"
                  >
                  <v-list-tile-action style="min-width:36px">
                    <v-icon>fa-times-circle-o</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Waive</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                -->

                <v-list-tile
                  @click="panel = 'receipt'"
                  :color="panel === 'receipt' ? 'primary' : ''"
                  v-if="transactionDetails.response_code === '000' && (transactionDetails.request_type !== 'ach' || transactionDetails.ach_is_authorized)"
                >
                  <v-list-tile-action style="min-width:36px">
                    <v-icon>fa-file-text</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      Receipt
                      <Lightbulb>
                        <template v-slot:message>
                          <span>Allows you to reprint or re-email a receipt to your customer.</span>
                        </template>
                      </Lightbulb>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile
                  :to="{ name: (transactionDetails.request_type === 'ach' || transactionDetails.request_type === 'achvoid' || transactionDetails.request_type === 'achcredit' ) ? 'ChargeACH' : 'ChargeCard', query: { transaction: transactionDetails.id }}"
                  @click="panel = 'charge'"
                  :color="panel === 'charge' ? 'primary' : ''"
                  v-if="hasPermission('can_use_virtual_terminal') && transactionDetails.token_id && transactionDetails.token_is_active"
                >
                  <v-list-tile-action style="min-width:36px">
                    <v-icon>fa-credit-card</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      Charge Customer
                      <Lightbulb>
                        <template v-slot:message>
                          <span>Allows you to recharge your customer with a new amount.</span>
                        </template>
                      </Lightbulb>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile
                  @click="panel = 'future'"
                  :color="panel === 'future' ? 'primary' : ''"
                  v-if="hasPermission('can_use_virtual_terminal') && transactionDetails.future_post && !transactionDetails.settled && !transactionDetails.voided"
                >
                  <v-list-tile-action style="min-width:36px">
                    <v-icon>fa-refresh</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Edit Payment</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <!--
                <v-list-tile @click="panel = 'recurring'" :color="panel === 'recurring' ? 'primary' : ''" v-if="(hasPermission('can_manage_transactions') || hasPermission('can_manage_account_transactions')) && transactionDetails.token_id && transactionDetails.is_recurring!==1">
                  <v-list-tile-action style="min-width:36px">
                    <v-icon>fa-refresh</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Add Recurring</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                -->

                <v-list-tile
                  @click="panel = 'recurring'"
                  :color="panel === 'recurring' ? 'primary' : ''"
                  v-if="(hasPermission('can_manage_transactions') || hasPermission('can_manage_account_transactions')) && ((transactionDetails.request_type === 'sale' && transactionDetails.response_code === '000') || transactionDetails.request_type === 'ach') && transactionDetails.is_recurring === 1 && !transactionDetails.voided && transactionDetails.parent_transaction_id === 0 && transactionDetails.reference_number"
                  >
                  <v-list-tile-action style="min-width:36px">
                    <v-icon>fa-refresh</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Edit Recurring</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile
                  @click="panel = 'modifications'"
                  :color="panel === 'modifications' ? 'primary' : ''"
                  v-if="(hasPermission('can_manage_transactions') || hasPermission('can_manage_account_transactions')) && transactionDetails.is_recurring === 1 && transactionDetails.modify_recurring_type !== null && !transactionDetails.voided"
                  >
                  <v-list-tile-action style="min-width:36px">
                    <v-icon>fa-exchange</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Modifications</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile
                  @click="panel = 'achreturn'"
                  :color="panel === 'achreturn' ? 'primary' : ''"
                  v-if="hasPermission('superuser') && ( transactionDetails.request_type === 'ach' || transactionDetails.request_type === 'achcredit' ) && transactionDetails.ach_status_id === 4 && transactionDetails.processor_transaction_id"
                  >
                  <v-list-tile-action style="min-width:36px">
                    <v-icon>fa-share</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      ACH Return
                      <Lightbulb>
                        <template v-slot:message>
                          <span>Marks an ACH transaction as returned and sends configured notifications.</span>
                        </template>
                      </Lightbulb>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

              </v-list>

              <div v-if="hasPermission('superuser')">
                <v-divider></v-divider>
                <div style="padding: 4px 16px 0; font-size: 11px; text-transform: uppercase; color: rgba(0,0,0,0.54); letter-spacing: 0.08em;">Admin Options</div>
                <v-list pa-0 ma-0>
                  <v-list-tile @click="hideTransaction()">
                    <v-list-tile-action style="min-width:36px">
                      <v-icon color="error">fa-eye-slash</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title class="error--text">Hide Transaction</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </div>


              <v-divider
                inset
                vertical
              ></v-divider>
            </v-flex>

            <v-flex xs10>
              <v-toolbar dense flat>
                <v-toolbar-title></v-toolbar-title>
                <v-spacer></v-spacer>
                <h3 class="primary--text text-capitalize">{{ panel }}</h3>
                <v-btn icon flat color="primary" @click.native="closeOptionsModal()">
                  <v-icon>fa-close</v-icon>
                </v-btn>
              </v-toolbar>

              <DetailsPanel :transaction="transactionDetails" v-if="panel === 'details'"/>

              <AssociatedPanel :transaction="transactionDetails" v-if="panel === 'associated'"/>

              <RefundPanel :transaction="transactionDetails" v-if="panel === 'refund' && (hasPermission('can_manage_transactions') || hasPermission('can_manage_account_transactions')) && ( transactionDetails.request_type === 'sale' || transactionDetails.request_type === 'ach' ) && transactionDetails.settled && !transactionDetails.voided && credited < transactionDetails.total_amount"/>

              <VoidPanel :transaction="transactionDetails" v-if="panel === 'void' && (hasPermission('can_manage_transactions') || hasPermission('can_manage_account_transactions')) && ( transactionDetails.request_type === 'sale' || transactionDetails.request_type === 'credit' || transactionDetails.request_type === 'ach' || transactionDetails.request_type === 'achcredit' ) && !transactionDetails.settled && !transactionDetails.voided && !transactionDetails.refunded"/>

              <ReceiptPanel :transaction="transactionDetails" v-if="panel === 'receipt'"/>

              <ModifyPanel :transaction="transactionDetails" :scheduledTransactions="scheduledTransactions" v-if="panel === 'recurring' && (hasPermission('can_manage_transactions') || hasPermission('can_manage_account_transactions')) && transactionDetails.token_id"/>

              <FuturePaymentPanel :transaction="transactionDetails" v-if="panel === 'future' && hasPermission('can_use_virtual_terminal')"/>

              <ModificationsPanel :transaction="transactionDetails" v-if="panel === 'modifications'"/>

              <AchReturnPanel :transaction="transactionDetails" v-if="panel === 'achreturn' && hasPermission('superuser') && ( transactionDetails.request_type === 'ach' || transactionDetails.request_type === 'achcredit' ) && transactionDetails.ach_status_id === 4 && transactionDetails.processor_transaction_id"/>
            </v-flex>
          </v-layout>
        </v-container>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Bus from '@/bus'
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import RecurringMixin from '@/mixins/recurring'
import StoreMixin from '@/store/mixin'

import AchReturnPanel from './AchReturn.vue'
import AssociatedPanel from './Associated.vue'
import DetailsPanel from './Details.vue'
import FuturePaymentPanel from './FuturePayment.vue'
import Lightbulb from '@/components/help/Lightbulb'
import ModificationsPanel from '../recurring/Modifications.vue'
import ModifyPanel from '../recurring/Modify.vue'
import ReceiptPanel from './Receipt.vue'
import RefundPanel from './Refund.vue'
import VoidPanel from './Void.vue'

export default {
  components: {
    AchReturnPanel,
    AssociatedPanel,
    DetailsPanel,
    FuturePaymentPanel,
    Lightbulb,
    ModificationsPanel,
    ModifyPanel,
    ReceiptPanel,
    RefundPanel,
    VoidPanel
  },

  mixins: [
    ApiMixin,
    AuthMixin,
    DisplayMixin,
    RecurringMixin,
    StoreMixin
  ],

  data: function () {
    return {
      enabled: false,
      panel: 'details',
      transactionDetails: {},
      scheduledTransactions: []
      // waive: false,
      // canWaive: false
    }
  },

  props: {
    round: Boolean,
    transaction: Object
  },

  created () {},

  beforeDestroy () {
    // Bus.$off('chargeWaiveFee')
    Bus.$off('closeOptionsModal')
    Bus.$off('openTransaction')
    this.panel = ''
    this.transactionDetails = Object.assign({}, {})
  },

  mounted () {
    // Bus.$on('chargeWaiveFee', this.showChargeOption)
    Bus.$on('closeOptionsModal', this.closeOptionsModal)
    Bus.$on('openTransaction', this.openTransaction)
  },

  computed: {
    credited: function () {
      if (!this.transactionDetails.hasOwnProperty('associatedTransactions') || this.transactionDetails.associatedTransactions.length < 1) {
        return 0
      }

      let totalCredited = this.transactionDetails.associatedTransactions.reduce((runningTotal, transaction) => {
        if ((transaction.request_type === 'credit' || transaction.request_type === 'achcredit') && transaction.response_code === '000' && transaction.parent_transaction_id === this.transactionDetails.id && !transaction.voided) {
          return runningTotal + transaction.total_amount
        }
        return runningTotal
      }, 0)

      return totalCredited
    }
  },

  methods: {
    async init () {},
    async showModal (panel = 'details') {
      try {
        let data = await this.api({url: `/transactions/${this.$props.transaction.id}`})
        this.transactionDetails = data.data.transaction

        if (!this.transactionDetails.custom) {
          this.transactionDetails.custom = {}
        } else {
          try {
            this.transactionDetails.custom = JSON.parse(this.transactionDetails.custom)
          } catch (error) {
            this.transactionDetails.custom = {}
          }
        }

        if (!this.transactionDetails.account_permissions) {
          this.transactionDetails.account_permissions = {}
        } else {
          try {
            this.transactionDetails.account_permissions = JSON.parse(this.transactionDetails.account_permissions)
          } catch (error) {
            this.transactionDetails.account_permissions = {}
          }
        }

        // this.transactionDetails = Object.assign({}, this.transactionDetails, data.data.transaction)
        // this.transactionDetails = {...this.transactionDetails}
        this.enabled = true
        this.panel = panel

        this.scheduledTransactions = this.getInstallments(this.transactionDetails)

        if (this.$route.query.id !== String(this.$props.transaction.id)) {
          this.$router.replace({
            query: { ...this.$route.query, id: this.$props.transaction.id }
          })
        }
      } catch (err) {
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      }
    },

    openTransaction () {
      this.panel = 'details'
      this.enabled = false
    },

    closeOptionsModal () {
      Bus.$emit('optionsClose')
      this.panel = ''
      this.enabled = false

      if (this.$route.query.id) {
        const query = { ...this.$route.query }
        delete query.id
        this.$router.replace({ query })
      }
    },

    async hideTransaction () {
      if (confirm('Are you sure you want to hide this transaction? It will no longer appear in transaction lists.')) {
        try {
          Bus.$emit('openWaitModal')
          await this.api({
            method: 'put',
            url: `/transactions/${this.transactionDetails.id}/hide`
          })
          Bus.$emit('closeWaitModal')
          Bus.$emit('openModal', {status: 'success', message: 'Transaction hidden successfully'})
          this.closeOptionsModal()
        } catch (err) {
          Bus.$emit('closeWaitModal')
          Bus.$emit('openModal', {
            status: 'error',
            message: err
          })
        }
      }
    },

    showChargeOption () {
      Bus.$emit('voidSuccessful')
      this.panel = 'charge'

      if (this.transactionDetails.request_type === 'ach' || this.transactionDetails.request_type === 'achvoid' || this.transactionDetails.request_type === 'achcredit') {
        this.$router.push({name: 'ChargeACH', query: { transaction: this.transactionDetails.id }})
      } else {
        this.$router.push({name: 'ChargeCard', query: { transaction: this.transactionDetails.id }})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/transactions/OptionsModal.vue